import { Financials as FinancialsFeature } from '../../features/Financials/Financials'

export const Financials = () => <FinancialsFeature />
